import {canReassignTasks} from '../../TaskManagement/taskTimerState';
import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Group from '../../entities/group';
import Role from '../../entities/role';
import Deadline from '../../entities/deadline';
import Task from '../../entities/task';
import TemplateTask from '../../entities/templateTask';
export function deleteGroup(group: Group, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = group.id;}
const _work = workingSet();
store.getState().roles.getMappingFor('groups', group.id).filter(roleTemp => roleTemp.status !== 'D').forEach(roleTemp => {
const _role = ((_work.get('role:' + roleTemp.id) ?? roleTemp) as Role).clone();
_role.status = 'U';
_role.addedOn = newHRTimestamp();
_role.addedBy = getCurrentUserId();
_role.importSource = targetImportSource;
_role.importId = mergeId;
_role.groups = _role.groups?.filter(id => id !== group.id) || [];

_work.set('role:' + _role.id, _role);
store.dispatch(Actions.RoleActions.saveRoleQueue(_role));
});
findAll<Deadline>('deadlines').filter(deadlineTemp => deadlineTemp.assignedToType === 'G' && deadlineTemp.assignedTo === group.id && deadlineTemp.status !== 'D').forEach(deadlineTemp => {
const _deadline = ((_work.get('deadline:' + deadlineTemp.id) ?? deadlineTemp) as Deadline).clone();

_deadline.status = 'U';
_deadline.addedOn = newHRTimestamp();
_deadline.addedBy = getCurrentUserId();
_deadline.importSource = targetImportSource;
_deadline.importId = mergeId;
_work.set('deadline:' + _deadline.id, _deadline);
store.dispatch(Actions.DeadlineActions.saveDeadlineQueue(_deadline));
});
findAll<Task>('tasks').filter(taskTemp => taskTemp.assignedToType === 'G' && taskTemp.assignedTo === group.id && taskTemp.status !== 'D').forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();

_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});
findAll<TemplateTask>('templateTasks').filter(templateTaskTemp => templateTaskTemp.assignedToType === 'G' && templateTaskTemp.assignedTo === group.id && templateTaskTemp.status !== 'D').forEach(templateTaskTemp => {
const _templateTask = ((_work.get('templateTask:' + templateTaskTemp.id) ?? templateTaskTemp) as TemplateTask).clone();

_templateTask.status = 'D';
_templateTask.addedOn = newHRTimestamp();
_templateTask.addedBy = getCurrentUserId();
_templateTask.importSource = targetImportSource;
_templateTask.importId = mergeId;
_work.set('templateTask:' + _templateTask.id, _templateTask);
store.dispatch(Actions.TemplateTaskActions.saveTemplateTaskQueue(_templateTask));
});


group.status = 'D';
group.addedOn = newHRTimestamp();
group.addedBy = getCurrentUserId();
group.importSource = targetImportSource;
group.importId = mergeId;
store.dispatch(Actions.GroupActions.removeGroupQueue(group));
}
export function replaceGroup(group: Group, replaceWith: Group, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = group.id;}
const _work = workingSet();
store.getState().roles.getMappingFor('groups', group.id).filter(roleTemp => roleTemp.status !== 'D').forEach(roleTemp => {
const _role = ((_work.get('role:' + roleTemp.id) ?? roleTemp) as Role).clone();
_role.status = 'U';
_role.addedOn = newHRTimestamp();
_role.addedBy = getCurrentUserId();
_role.importSource = targetImportSource;
_role.importId = mergeId;
_role.groups = _role.groups?.map(id => (id === group.id) ? replaceWith.id : id) || [];

_work.set('role:' + _role.id, _role);
store.dispatch(Actions.RoleActions.saveRoleQueue(_role));
});
findAll<Deadline>('deadlines').filter(deadlineTemp => deadlineTemp.assignedToType === 'G' && deadlineTemp.assignedTo === group.id && deadlineTemp.status !== 'D').forEach(deadlineTemp => {
const _deadline = ((_work.get('deadline:' + deadlineTemp.id) ?? deadlineTemp) as Deadline).clone();
_deadline.assignedTo = replaceWith.id;
_deadline.status = 'U';
_deadline.addedOn = newHRTimestamp();
_deadline.addedBy = getCurrentUserId();
_deadline.importSource = targetImportSource;
_deadline.importId = mergeId;
_work.set('deadline:' + _deadline.id, _deadline);
store.dispatch(Actions.DeadlineActions.saveDeadlineQueue(_deadline));
});
findAll<Task>('tasks').filter(taskTemp => taskTemp.assignedToType === 'G' && taskTemp.assignedTo === group.id && taskTemp.status !== 'D').filter(canReassignTasks).forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
_task.assignedTo = replaceWith.id;
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});
findAll<TemplateTask>('templateTasks').filter(templateTaskTemp => templateTaskTemp.assignedToType === 'G' && templateTaskTemp.assignedTo === group.id && templateTaskTemp.status !== 'D').forEach(templateTaskTemp => {
const _templateTask = ((_work.get('templateTask:' + templateTaskTemp.id) ?? templateTaskTemp) as TemplateTask).clone();
_templateTask.assignedTo = replaceWith.id;
_templateTask.status = 'U';
_templateTask.addedOn = newHRTimestamp();
_templateTask.addedBy = getCurrentUserId();
_templateTask.importSource = targetImportSource;
_templateTask.importId = mergeId;
_work.set('templateTask:' + _templateTask.id, _templateTask);
store.dispatch(Actions.TemplateTaskActions.saveTemplateTaskQueue(_templateTask));
});


return group;
}
export function deleteImpactGroup(group: Group) {
const impacts: string[] = [];
const state = store.getState();
const roleGroupsImpact = state.roles.getMappingFor('groups', group.id).filter(role => role.status !== 'D');
roleGroupsImpact.forEach(() => impacts.push('roles'));
const deadlineAssignedToTypeImpact = findAll<Deadline>('deadlines').filter(deadline => deadline.assignedToType === 'G' && deadline.assignedTo === group.id && deadline.status !== 'D');
deadlineAssignedToTypeImpact.forEach(() => impacts.push('deadlines'));
const taskAssignedToTypeImpact = findAll<Task>('tasks').filter(task => task.assignedToType === 'G' && task.assignedTo === group.id && task.status !== 'D');
taskAssignedToTypeImpact.forEach(() => impacts.push('tasks'));
const templateTaskAssignedToTypeImpact = findAll<TemplateTask>('templateTasks').filter(templateTask => templateTask.assignedToType === 'G' && templateTask.assignedTo === group.id && templateTask.status !== 'D');
templateTaskAssignedToTypeImpact.forEach(() => impacts.push('templateTasks'));


return util.countDistinct(impacts);
}
